import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

import { selectServerConfig } from "~/redux/selectors/appSelectors";

import { useAppSelector } from "./store";

export function RedirectToAutostoreMain({ children }: PropsWithChildren) {
  const manualOpsEnabled = useAppSelector(selectServerConfig).manualOpsEnabled;

  return manualOpsEnabled === false ? (
    <Navigate to="/autostore-main" replace />
  ) : (
    children
  );
}
